import React from "react";
import { Box, Typography } from "@mui/material";
import Spinner from "../Assets/images/loading.gif";

export const LoadingPage = ({ height }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 1400,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: height || "100vh",
        width: "100%",
        gap: 2,
        background: "transparent", // Allow background to shine through if parent has one, or white by default
        animation: "fadeIn 0.8s ease-out",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          animation: "float 3s ease-in-out infinite", // Subtle floating effect
        }}
      >
        <img
          src={Spinner}
          alt="loading"
          width={80} // Maintaining original size but it was small, maybe slightly larger? User asked to keep original spinner.
          style={{
            filter: "drop-shadow(0 8px 16px rgba(0,0,0,0.1))", // Modern shadow
            display: "block",
          }}
        />
      </Box>

      <Typography
        variant="body2"
        sx={{
          color: "#8898aa",
          fontWeight: 600,
          letterSpacing: "2px",
          textTransform: "uppercase",
          fontSize: "0.7rem",
          mt: 1,
          animation: "pulse 2s infinite ease-in-out",
        }}
      >
        Loading...
      </Typography>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
      `}</style>
    </Box>
  );
};
